<div class="header-pink {{ size }}">
  <div class="container">
    <div class="row">
      <div class="heading-text">
        <h1 class="main-title" *ngIf="title">{{ title }}</h1>
      </div>
    </div>
    <ng-content></ng-content>
  </div>
</div>
